import { useContext } from "react";
import { LocaleContext } from "../../contexts/locale/locale";
import { ProfileItem } from "./profile-item/profile-item";
import classes from "./profile.module.css";

export const Profile = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<section className={classes.profile} id="profile">
			<h3>{texts.profile.title}</h3>
			<p>{texts.profile.description}</p>
			<div>
				<ProfileItem
					title={texts.profile.list.assetClasses.title}
					icon="/icons/profile/asset-classes.svg"
					values={texts.profile.list.assetClasses.values}
				/>
				<ProfileItem
					title={texts.profile.list.location.title}
					icon="/icons/profile/location.svg"
					values={texts.profile.list.location.values}
				/>
				<ProfileItem
					title={texts.profile.list.riskClassAndProperties.title}
					icon="/icons/profile/risk-class-and-properties.svg"
					values={texts.profile.list.riskClassAndProperties.values}
				/>
				<ProfileItem
					title={texts.profile.list.volume.title}
					icon="/icons/profile/volume.svg"
					values={texts.profile.list.volume.values}
				/>
			</div>
		</section>
	);
};
